import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauth-message',
  templateUrl: './unauth-message.component.html',
  styleUrls: ['./unauth-message.component.css']
})
export class UnauthMessageComponent implements OnInit {

  constructor(private router: Router) { }
 

  ngOnInit(): void {
  }
   
   goToHome(): void {
    this.router.navigate(['/home']);
  }
}
